import React, { useEffect } from "react";
import { X, Plus, Minus } from "lucide-react";
import { useI18n } from "../data/i18n";

const ProductDetailModal = ({ item, open, onClose, qty, setQty, onAdd }) => {
  const { t } = useI18n();

  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  if (!open || !item) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 modal-overlay-animate" onClick={onClose}>
      <div className="relative bg-[#0c0c0c] border border-[#1f1f1f] max-w-4xl w-full max-h-[90vh] overflow-y-auto modal-content-animate" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 z-10 w-10 h-10 bg-[#0a0a0a]/80 border border-[#2a2a2a] text-[#cfc7b8] hover:text-[#e4c590] hover:border-[#e4c590] flex items-center justify-center transition-colors" aria-label="Close">
          <X size={18} />
        </button>
        <div className="grid grid-cols-1 md:grid-cols-2">
          {item.image && (
            <div className="aspect-[4/3] md:aspect-auto md:h-full bg-[#0a0a0a] overflow-hidden">
              <img src={item.image} alt={item.name} className="w-full h-full object-cover" decoding="async" onError={(e) => { e.currentTarget.style.opacity = "0.2"; }} />
            </div>
          )}
          <div className="p-8 lg:p-10 flex flex-col">
            <p className="text-[#e4c590] uppercase tracking-widest text-xs mb-3">CASA BALA</p>
            <h2 className="display text-3xl md:text-4xl text-[#f5f0e6] mb-4">{item.name}</h2>
            <div className="flex items-center gap-2 mb-6">
              <span className="diamond-mark"></span>
              <span className="diamond-mark opacity-60"></span>
              <span className="diamond-mark"></span>
            </div>
            {item.desc && <p className="text-[#cfc7b8] leading-relaxed mb-6 text-sm">{item.desc}</p>}
            {item.weight && <p className="text-[#7a7468] text-xs uppercase tracking-widest mb-6">{t("menu.weight")}: <span className="text-[#cfc7b8]">{item.weight}</span></p>}
            <div className="mt-auto pt-6 border-t border-[#1f1f1f]">
              <div className="flex items-end justify-between mb-6">
                <div>
                  <p className="text-[#7a7468] text-xs uppercase tracking-widest mb-1">{t("menu.price")}</p>
                  <p className="text-[#e4c590] text-2xl display">{item.priceRaw}</p>
                </div>
                {setQty && (
                  <div className="flex items-center gap-3">
                    <button onClick={() => setQty(Math.max(1, qty - 1))} className="w-9 h-9 border border-[#e4c590]/50 text-[#e4c590] flex items-center justify-center hover:bg-[#e4c590] hover:text-[#0a0a0a] transition-colors"><Minus size={14} /></button>
                    <span className="text-[#f5f0e6] w-8 text-center display text-xl">{qty}</span>
                    <button onClick={() => setQty(qty + 1)} className="w-9 h-9 border border-[#e4c590]/50 text-[#e4c590] flex items-center justify-center hover:bg-[#e4c590] hover:text-[#0a0a0a] transition-colors"><Plus size={14} /></button>
                  </div>
                )}
              </div>
              {onAdd && (
                <button className="cb-btn cb-btn-gold w-full" onClick={onAdd}>
                  <span className="cb-btn-text cb-btn-text-1">{t("menu.add_to_order")}</span>
                  <span className="cb-btn-text cb-btn-text-2" aria-hidden="true">{t("menu.add_to_order")}</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailModal;
